import React, { Component, Fragment } from 'react'
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class Tabset_user extends Component {

    constructor(props) {
        super(props)
        this.state = {
            user: ''
        }
        this.onUserCreateHandler = this.onUserCreateHandler.bind(this)
    }

    onUserCreateHandler(e) {
        e.preventDefault()
        const pass = e.target.password.value
        const confirmPass = e.target.confirmPassword.value
        // console.log(pass)
        if (!this.validateEmail(e.target.email.value)) {
            toast.error("Invalid Email.")
            return
        }
        if (pass == confirmPass && pass != "") {
            const params = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    firstName: e.target.firstName.value,
                    lastName: e.target.lastName.value,
                    email: e.target.email.value,
                    password: e.target.password.value,
                    isAdmin: false
                })
            }
            
            fetch(`${process.env['REACT_APP_HOST']}/api/users`, params)
                .then(res => res.json())
                .then(data => {
                    data.error === false ? toast.success(data.message) : toast.error(data.message)
                    
                    // if (data.message) {
                    //     toast.error(data.message)
                    // } else {
                    //     toast.success("User created successfully")
                    //     // window.location.href = '/users/list-user';
                    //     document.getElementById("myForm").reset();
                    // }

                })
        } else {
            toast.error("Password and confirm password doesn't match")
        }
    }
    validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    render() {
        return (
            <Fragment>
                <Tabs>
                    <TabList className="nav nav-tabs tab-coupon" >
                        <Tab className="nav-link">Account</Tab>
                        {/* <Tab className="nav-link">Permission</Tab> */}
                    </TabList>
                    <TabPanel>
                        <form id="myForm" method='post' onSubmit={this.onUserCreateHandler} className="needs-validation user-add" noValidate>
                            <h4>Account Details</h4>
                            <div className="form-group row">
                                <label className="col-xl-3 col-md-4"><span>*</span> First Name</label>
                                <input name="firstName" className="form-control col-xl-8 col-md-7" id="validationCustom0" type="text" required />
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-md-4"><span>*</span> Last Name</label>
                                <input name="lastName" className="form-control col-xl-8 col-md-7" id="validationCustom1" type="text" required />
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-md-4"><span>*</span> Email</label>
                                <input name="email" className="form-control col-xl-8 col-md-7" id="validationCustom2" type="text" required />
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-md-4"><span>*</span> Password</label>
                                <input name="password" className="form-control col-xl-8 col-md-7" id="validationCustom3" type="password" required />
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-md-4"><span>*</span> Confirm Password</label>
                                <input name="confirmPassword" className="form-control col-xl-8 col-md-7" id="validationCustom4" type="password" required />
                            </div>
                            <div className="form-group row">
                                <div className="col-md-11 text-right pr-0">
                                   <button type="submit" className="btn btn-primary">Save</button>
                                </div>
                            
                            </div>
                        </form>
                    </TabPanel>

                </Tabs>
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Tabset_user
